import { render } from "./Secrets.vue?vue&type=template&id=435fe1a8"
import script from "./Secrets.vue?vue&type=script&lang=js"
export * from "./Secrets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/Secrets.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "435fe1a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('435fe1a8', __exports__)) {
    api.reload('435fe1a8', __exports__)
  }
  
  module.hot.accept("./Secrets.vue?vue&type=template&id=435fe1a8", () => {
    api.rerender('435fe1a8', render)
  })

}


export default __exports__